import React from 'react';
import { GlassCard } from '../../ui/Card';

const WorkFormatsSkeleton: React.FC = () => {
    return (
        <section className="section formats-section">
            <div className="container">
                <div className="formats-grid">
                    {[...Array(3)].map((_, i) => (
                        <GlassCard key={i}>
                            <div className="skeleton-line" style={{ width: '40px', height: '40px', borderRadius: '50%', marginBottom: '16px' }}></div>
                            <div className="skeleton-line skeleton-title" style={{ width: '60%', height: '24px', marginBottom: '16px' }}></div>
                            <div className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                            <div className="skeleton-line skeleton-short" style={{ marginBottom: '16px' }}></div>
                            <div className="skeleton-line" style={{ width: '80%', height: '16px' }}></div>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WorkFormatsSkeleton;
